<template>
	<metainfo>
		<template #description="{ content }">
			{{ content }}
		</template>
	</metainfo>
	<router-view @vue:mounted="routerViewMounted"/>
	<!-- <div class="debug">
		<div>
			reponsive :
			<span class="debug__layout-full">@layoutFull</span>
			<span class="debug__layout-one-aside">@layoutOneAside</span>
			<span class="debug__layout-no-aside">@layoutNoAside</span>
			<span class="debug__layout-nav-full">@layoutNavFull</span>
			<span class="debug__layout-nav-collapsed">@layoutNavCollapsed</span>
			<span class="debug__layout-nav-bottom">@layoutNavBottom</span>
			<span class="debug__phone">@phone</span>
		</div>
	</div> -->
</template>

<script setup lang="ts">
const SessionManager = () => import('@/utils/SessionManager');
function routerViewMounted () {
	SessionManager();
}
</script>

<style lang="less">
@import "https://fonts.googleapis.com/css?family=Source+Sans+Pro:200,300,400,600,700";
@import "@/styles/styles.less";
@import "@/styles/variables";

#app {
	overflow-x: hidden;
	display: flex;
	height: 100vh;
	height: 100dvh;
	-webkit-overflow-scrolling: touch;
}

#freshworks-frame-wrapper {
	right: unset !important;
	bottom: 20px !important;
	left: calc(var(--arm-aside-width) + 2rem);

	@media @layoutNavCollapsed {
		left: calc(var(--arm-nav-collpased-width) + 1rem);
	}

	@media @layoutNavBottom {
		left: 1rem;
	}
}

@keyframes slideupright {
	from {
		transform-origin: top left;
		transform: scale(0);
	}

	to {
		transform-origin: top left;
		transform: scale(1);
	}
}
</style>
